import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `FichaVerraco/getFiltrarVerraco`, method: 'POST', body: values, token: token})
}